import { Component } from '@angular/core';

import { CheckoutService } from '../../../../../checkout/checkout.service';
import { IExchangeCar } from '../../../../../exchange-car/exchange-car.models';
import { ExchangeCarService } from '../../../../../exchange-car/exchange-car.service';
import { SidePanelService } from '../../../../../side-panel/side-panel.service';

@Component({
    selector: 'app-checkout-step-exchange-car-list',
    template: `
        <section class="flow-step">
            <h5>
                {{ 'checkout.exchange_car_step____choose_exchange_car_list____headline' | translate }}
            </h5>
            <p>
                {{ 'checkout.exchange_car_step____choose_exchange_car_list____text' | translate }}
            </p>
            <section class="flow-step__content" *ngIf="checkoutService.getCheckoutData() | async as cd">
                <!-- <app-fade-in> -->
                    <ul *ngIf="exchangeCarService.exchangeCars | async as exchangeCars" class="exchange-car-list animate-fade-in">
                        <li
                            *ngFor="let car of exchangeCars"
                            (click)="handleSetExchangeCar(car)"
                            class="exchange-car-list-item"
                            [class.exchange-car-list-item--active]="
                                (car.valuationUrl === cd.exchangeCar?.indicataUrl && (selectedCar ? car.id === selectedCar?.id : true)) ||
                                car.id === selectedCar?.id
                            "
                            appCircleCheckmark
                            [condition]="
                                (car.valuationUrl === cd.exchangeCar?.indicataUrl && (selectedCar ? car.id === selectedCar?.id : true)) ||
                                (selectedCar ? car.id === selectedCar?.id : false)
                            "
                        >
                            <div
                                class="exchange-car-list-item__content exchange-car-list-item__content--left"
                                [class.exchange-car-list-item__content--loading]="car.id === selectedCar?.id"
                            >
                                <h5>
                                    {{ car.make?.summary }} {{ car.model?.summary }} <span *ngIf="car.trim?.summary">- {{ car.trim?.summary }}</span>
                                </h5>
                                <p class="text-small no-margin">
                                    <span *ngIf="car.identifier" class="exchange-car-list-item__detail">
                                        {{ car.identifier }}
                                    </span>
                                    <span class="exchange-car-list-item__detail">
                                        {{ car.engine?.summary }}
                                    </span>
                                    <span class="exchange-car-list-item__detail">
                                        {{ car.regDate?.summary }}
                                    </span>
                                    <span class="exchange-car-list-item__detail">
                                        {{ car.odometer?.distance }} {{ 'generic.kilometers_abbrev' | translate }}
                                    </span>
                                </p>
                            </div>
                            <div class="exchange-car-list-item__content exchange-car-list-item__content--right">
                                <h5 *ngFor="let valuation of car?.valuations" class="exchange-car-list-item__valuation">
                                    {{ valuation?.amount?.value | defaultcurrency }}
                                </h5>
                                <p
                                    class="link text-small theme-text no-margin"
                                    *ngIf="car.id"
                                    (click)="exchangeCarService.removedExchangeCar(car.id)"
                                >
                                    {{ 'generic.remove' | translate }}
                                </p>
                            </div>
                            <div
                                class="exchange-car-list-item__loader"
                                *ngIf="(checkoutService.isCheckoutLoading$ | async) && selectedCar?.id === car.id"
                            >
                                <div class="loader"></div>
                            </div>
                        </li>

                        <li>
                            <app-button
                                (handleClick)="handleIndicataClick()"
                                [buttonClass]="'button--tertiary button--has-spacing'"
                                [title]="'checkout.exchange_car_step____button_____add_new' | translate"
                            ></app-button>
                        </li>

                        <li>
                            <p class="text-small">{{ 'indicata.valuation_summary____info_text' | translate }}</p>
                        </li>
                    </ul>
                <!-- </app-fade-in> -->
            </section>
        </section>
    `,
})
export class CheckoutStepExchangeCarListComponent {
    selectedCar?: IExchangeCar;
    constructor(
        public checkoutService: CheckoutService,
        private sidepanelService: SidePanelService,
        public exchangeCarService: ExchangeCarService
        ) {}

    handleIndicataClick() {
        this.sidepanelService.showExhangeCarSidePanel();
    }

    handleSetExchangeCar(car: IExchangeCar) {
        this.selectedCar = car;
        this.checkoutService.setExchangeCar(car);
    }
}
